import { lazy } from 'react'

// gtype → dedicated game page (lazy = per-game code splitting).
// Naya game banate time: games/<gtype>/ folder banao aur yahan register karo.
// Jo gtype yahan nahi hai wo generic CasinoGameScreen se render hota hai.
export const GAME_PAGES = {
  goal: lazy(() => import('./games/goal/Goal')),
  ab4: lazy(() => import('./games/ab4/AB4')),
  lucky15: lazy(() => import('./games/lucky15/Lucky15')),
  teenpatti41: lazy(() => import('./games/teenpatti41/Teen41')),
  teenpatti42: lazy(() => import('./games/teenpatti42/Teen42')),
  sicbo2: lazy(() => import('./games/sicbo2/SicBo2')),
  sicbo: lazy(() => import('./games/sicbo/SicBo')),
  teenpattiinstant3: lazy(() => import('./games/teenpattiinstant3/InstantTeen3')),
  ballbyball: lazy(() => import('./games/ballbyball/BallByBall')),
  teenpattiinstant2: lazy(() => import('./games/teenpattiinstant2/InstantTeen2')),
  teenpattioneday: lazy(() => import('./games/teenpattioneday/TeenOneDay')),
  goal2: lazy(() => import('./games/goal2/Goal2')),
  worli3: lazy(() => import('./games/worli3/Worli3')),
  teen62: lazy(() => import('./games/teen62/Teen62')),
  dolidana: lazy(() => import('./games/dolidana/Dolidana')),
  lucky5: lazy(() => import('./games/lucky5/Lucky5')),
  mogambo: lazy(() => import('./games/mogambo/Mogambo')),
  roulette12: lazy(() => import('./games/roulette12/Roulette12')),
  roulette13: lazy(() => import('./games/roulette13/Roulette13')),
  roulette11: lazy(() => import('./games/roulette11/Roulette11')),
  ourroullete: lazy(() => import('./games/ourroullete/OurRoulette')),
  poison: lazy(() => import('./games/poison/Poison')),
  teenunique: lazy(() => import('./games/teenunique/TeenUnique')),
  poisonteenpatti20: lazy(() => import('./games/poisonteenpatti20/Poison20')),
  jokerteenpatti120: lazy(() => import('./games/jokerteenpatti120/Joker120')),
  jokerteenpatti20: lazy(() => import('./games/jokerteenpatti20/Joker20')),
  jokerteenpatti1: lazy(() => import('./games/jokerteenpatti1/Joker1')),
  teenpattit20c: lazy(() => import('./games/teenpattit20c/Teen20c')),
  bollywoodtable2: lazy(() => import('./games/bollywoodtable2/Btable2')),
  superover3: lazy(() => import('./games/superover3/SuperOver3')),
  superover2: lazy(() => import('./games/superover2/SuperOver2')),
  teenpattit20: lazy(() => import('./games/teenpatti20/Teen20')),
  teenpattitest: lazy(() => import('./games/teenpattitest/TeenpattiTest')),
  teenpattiopen: lazy(() => import('./games/teenpattiopen/TeenpattiOpen')),
  pokeroneday: lazy(() => import('./games/pokeroneday/PokerOneDay')),
  poker20: lazy(() => import('./games/poker20/Poker20')),
  poker6player: lazy(() => import('./games/poker6player/Poker6Player')),
  baccarat: lazy(() => import('./games/baccarat/Baccarat')),
  baccarat2: lazy(() => import('./games/baccarat2/Baccarat2')),
  dragontigert20: lazy(() => import('./games/dragontigert20/DragonTiger20')),
  dragontigeroneday: lazy(() => import('./games/dragontigeroneday/DragonTigerOneDay')),
  dragontigerliont20: lazy(() => import('./games/dragontigerliont20/DragonTigerLion20')),
  dragontigert202: lazy(() => import('./games/dragontigert202/DragonTiger202')),
  card32a: lazy(() => import('./games/card32a/Card32A')),
  card32b: lazy(() => import('./games/card32b/Card32B')),
  'andar-bahar': lazy(() => import('./games/andar-bahar/AndarBahar')),
  'andar-bahar2': lazy(() => import('./games/andar-bahar2/AndarBahar2')),
  lucky7: lazy(() => import('./games/lucky7/Lucky7')),
  lucky7eu: lazy(() => import('./games/lucky7eu/Lucky7Eu')),
  '3cardj': lazy(() => import('./games/3cardj/ThreeCardJ')),
  war: lazy(() => import('./games/war/CasinoWar')),
  worli: lazy(() => import('./games/worli/WorliMatka')),
  instantworli: lazy(() => import('./games/instantworli/InstantWorli')),
  aaa: lazy(() => import('./games/aaa/AmarAkbarAnthony')),
  bollywoodtable: lazy(() => import('./games/bollywoodtable/Btable')),
  lottery: lazy(() => import('./games/lottery/Lottery')),
  cricketv3: lazy(() => import('./games/cricketv3/CricketV3')),
  cmatch20: lazy(() => import('./games/cmatch20/CricketMatch20')),
  meter: lazy(() => import('./games/meter/CasinoMeter')),
  teenpatti2: lazy(() => import('./games/teenpatti2/Teenpatti2')),
  queen: lazy(() => import('./games/queen/Queen')),
  race20: lazy(() => import('./games/race20/Race20')),
  lucky7eu2: lazy(() => import('./games/lucky7eu2/Lucky7Eu2')),
  superover: lazy(() => import('./games/superover/SuperOver')),
  trap: lazy(() => import('./games/trap/Trap')),
  teenpatti2cards: lazy(() => import('./games/teenpatti2cards/Teenpatti2Cards')),
  '29cardbaccarat': lazy(() => import('./games/cardbaccarat29/CardBaccarat29')),
  teenmuf: lazy(() => import('./games/teenmuf/Muflis')),
  raceto17: lazy(() => import('./games/raceto17/RaceTo17')),
  teenpattit20b: lazy(() => import('./games/teenpattit20b/Teen20b')),
  trio: lazy(() => import('./games/trio/Trio')),
  notenum: lazy(() => import('./games/notenum/NoteNumber')),
  '1card2020': lazy(() => import('./games/onecard2020/OneCard2020')),
  '1card1day': lazy(() => import('./games/onecardoneday/OneCardOneDay')),
  ab3: lazy(() => import('./games/ab3/AB3')),
  aaa2: lazy(() => import('./games/aaa2/AmarAkbarAnthony2')),
  race2: lazy(() => import('./games/race2/Race2')),
  teenpattiinstant: lazy(() => import('./games/teenpattiinstant/InstantTeen')),
  dum10: lazy(() => import('./games/dum10/Dum10')),
  cmeter1: lazy(() => import('./games/cmeter1/OneCardMeter')),
}

// Vip Casino list ke tiles — /admin/casino/vip/:gtype. Slug wahi ho sakta hai
// jo Our Casino me hai (teenpattit20) par feed alag (teen20v1), isliye alag map.
export const VIP_GAME_PAGES = {
  teenpattit20: lazy(() => import('./games/teenpatti20/Teen20Vip')),
}

// Virtual Casino list ke tiles — /admin/vcasino/:gtype (catalog route ka slug,
// feed type v<slug>: dtl20 → vdtl20).
export const VCASINO_GAME_PAGES = {
  dtl20: lazy(() => import('./games/vdtl20/VDtl20')),
  aaa: lazy(() => import('./games/vaaa/VAaa')),
  teenmuf: lazy(() => import('./games/vteenmuf/VMuflis')),
  dt6: lazy(() => import('./games/vdt6/VDt6')),
  teen: lazy(() => import('./games/vteen/VTeen1Day')),
  lucky7: lazy(() => import('./games/vlucky7/VLucky7')),
  btable: lazy(() => import('./games/vbtable/VBtable')),
  teen20: lazy(() => import('./games/vteen20/VTeen20')),
  trio: lazy(() => import('./games/vtrio/VTrio')),
}

// Premium Casino list ke tiles — /admin/pcasino/:gtype (tile id = feed type).
export const PCASINO_GAME_PAGES = {
  pteen: lazy(() => import('./games/pteen/PTeen')),
  pteen20: lazy(() => import('./games/pteen20/PTeen20')),
  pbaccarat: lazy(() => import('./games/pbaccarat/PBaccarat')),
  pdt20: lazy(() => import('./games/pdt20/PDt20')),
  pdt6: lazy(() => import('./games/pdt6/PDt6')),
  pcard32: lazy(() => import('./games/pcard32/PCard32')),
  plucky7: lazy(() => import('./games/plucky7/PLucky7')),
}
